import service from '../utils/request'
// 查询列表
export const querypayway = params => {return service.post(`/api/base_payway/query`, params)};
// 创建
export const createpayway = params => {return service.post(`/api/base_payway/create`, params)};
// 修改
export const editpayway = params => {return service.put(`/api/base_payway/edit`, params)};
// 删除
export const deletepayway = params => {return service.delete(`/api/base_payway/delete`, {params})};
